import { Injectable } from '@angular/core';
import { ErrorService } from './error.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class DataCatalogService {

  constructor(
    private httpService: HttpService,
    private errorService: ErrorService,
  ) { }

  public getDataCatalogs(withStatus: boolean): Promise<any[]> {
    let request = '**/data-catalogs/getAll';
    if (withStatus) {
      request = '**/data-catalogs/getAllWithStatus';
    }

    return new Promise((resolve, reject) => {
      return this.httpService.get(request).then((dataCatalogs: any[]) => {
        return resolve(dataCatalogs);
      }).catch((err) => {
        this.errorService.printError(err);
        return reject();
      })
    })
  }

}
